// Guide data and configurations
export const GUIDES = [
  {
    id: "storm-damage-checklist",
    title: "Storm Damage Checklist",
    description: "A comprehensive checklist to help you identify and document storm damage to your home. Essential for insurance claims.",
    color: "orange",
    pages: "8 pages",
    includes: [
      "Exterior inspection checklist",
      "Interior damage signs to look for",
      "Photo documentation tips",
      "Insurance company contact template",
      "Timeline for filing claims"
    ],
    popular: true
  },
  {
    id: "insurance-claim-guide",
    title: "Insurance Claim Survival Guide",
    description: "Navigate the insurance claim process with confidence. Learn what to expect and how to maximize your coverage.",
    color: "blue",
    pages: "12 pages",
    includes: [
      "Step-by-step claim process",
      "What adjusters look for",
      "Documentation requirements",
      "Common claim mistakes to avoid",
      "Supplemental claim strategies"
    ],
    popular: true
  },
  {
    id: "roof-inspection-checklist",
    title: "Roof Inspection Checklist",
    description: "Know what to look for when inspecting your roof. Perfect for before and after storm season preparation.",
    color: "green",
    pages: "6 pages",
    includes: [
      "Shingle condition assessment",
      "Flashing and vent inspection",
      "Gutter system evaluation",
      "Attic inspection guide",
      "When to call a professional"
    ],
    popular: false
  },
  {
    id: "contractor-hiring-guide",
    title: "Contractor Hiring Guide",
    description: "Everything you need to know about finding, vetting, and hiring a reputable roofing contractor in Minnesota.",
    color: "purple",
    pages: "10 pages",
    includes: [
      "Contractor vetting checklist",
      "Questions to ask before hiring",
      "Red flags to watch for",
      "Contract essentials",
      "Warranty understanding guide"
    ],
    popular: false
  },
  {
    id: "minnesota-roofing-guide",
    title: "Minnesota Roofing Guide",
    description: "Everything Minnesota homeowners need to know about roofing in our unique climate.",
    color: "navy",
    pages: "15 pages",
    includes: [
      "Best materials for MN climate",
      "Ice dam prevention",
      "Seasonal maintenance schedule",
      "Cost expectations",
      "Local building codes overview"
    ],
    popular: false
  }
];

export const colorClasses = {
  orange: "bg-orange/10 text-orange border-orange/20",
  blue: "bg-blue-500/10 text-blue-600 border-blue-500/20",
  green: "bg-green-500/10 text-green-600 border-green-500/20",
  purple: "bg-purple-500/10 text-purple-600 border-purple-500/20",
  navy: "bg-navy/10 text-navy border-navy/20"
};

export const iconBgClasses = {
  orange: "bg-orange",
  blue: "bg-blue-500",
  green: "bg-green-500",
  purple: "bg-purple-500",
  navy: "bg-navy"
};

// Get subtitle for guide
export const getGuideSubtitle = (guideId) => {
  const subtitles = {
    'storm-damage-checklist': 'Your Complete Post-Storm Home Inspection Guide for Minnesota Homeowners',
    'insurance-claim-guide': 'Navigate Your Storm Damage Insurance Claim with Confidence',
    'roof-inspection-checklist': 'Know What to Look For When Inspecting Your Minnesota Roof',
    'contractor-hiring-guide': 'Find, Vet, and Hire the Right Roofing Contractor',
    'minnesota-roofing-guide': 'Everything Minnesota Homeowners Need to Know About Roofing'
  };
  return subtitles[guideId] || 'A Comprehensive Guide for Minnesota Homeowners';
};
